"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    theme: _propTypes.default.string,
    size: _propTypes.default.string,
    showText: _propTypes.default.bool,
    translation: _propTypes.default.shape({
      nonStop: _propTypes.default.string,
      singleStop: _propTypes.default.string,
      multiStop: _propTypes.default.string
    }),
    designator: _propTypes.default.shape({
      departureStation: _propTypes.default.string,
      arrivalStation: _propTypes.default.string,
      departureTime: _propTypes.default.string,
      arrivalTime: _propTypes.default.string
    }).isRequired,
    segments: _propTypes.default.arrayOf(_propTypes.default.shape({
      designator: _propTypes.default.shape({
        departureStation: _propTypes.default.string,
        arrivalStation: _propTypes.default.string,
        departureTime: _propTypes.default.string,
        arrivalTime: _propTypes.default.string
      }),
      duration: _propTypes.default.number,
      layoverTime: _propTypes.default.number
    }))
  },
  DefaultProps: {
    accessible: true,
    customProperties: {},
    theme: _constant.DEFAULT_THEME,
    size: 'large',
    designator: {},
    segments: [],
    showText: false,
    translation: {}
  }
};
exports.default = _default;